import * as Flags from "country-flag-icons/react/3x2";
import { getData } from "country-list";
import { useMemo } from "react";

interface CountryItemProps {
  country: string;
  city?: string;
}

export const CountryItem = ({ country, city }: CountryItemProps) => {
  const selectedCountry = useMemo(() => {
    return getData().find((option) => option.name === country);
  }, [country]);

  const Flag = selectedCountry ? Flags[selectedCountry.code as keyof typeof Flags] : undefined;

  return (
    <div className="flex items-center gap-2">
      {Flag && <Flag className="h-4 w-auto" />}

      {selectedCountry ? selectedCountry.name : "-"}
      {city && <span className="text-muted-foreground">({city})</span>}
    </div>
  );
};
